__turbopack_context__.v({
  "active": "index-module__mT7Fmq__active",
  "controls": "index-module__mT7Fmq__controls",
  "controlsPoints": "index-module__mT7Fmq__controlsPoints",
  "controlsPointsDark": "index-module__mT7Fmq__controlsPointsDark",
  "fillPourcent": "index-module__mT7Fmq__fillPourcent",
  "scrollPourcent": "index-module__mT7Fmq__scrollPourcent",
  "scrollerChild": "index-module__mT7Fmq__scrollerChild",
  "sliderChildrenList": "index-module__mT7Fmq__sliderChildrenList",
  "sliderContainer": "index-module__mT7Fmq__sliderContainer",
});
